import { i18n } from '@goodboydigital/astro';
import { Texture } from '@pixi/core';
import { Sprite } from '@pixi/sprite';

import { App, Shared } from '../../App';
import { RankBadge } from '../RankBadge';
import { RankPointsLabel } from '../RankPointsLabel';
import { RankStatPair } from '../RankStatPair';
import { RankTitleLabel } from '../RankTitleLabel';
import { UserIdentity } from '../UserIdentity';
import { Popup } from './Popup';

export class RankStatsPopup extends Popup
{
    private div: Sprite;

    private badge: RankBadge;
    private identity: UserIdentity;
    private rankTitle: RankTitleLabel;
    private rankPoints: RankPointsLabel;

    private statPoints: RankStatPair;
    private statNextPoints: RankStatPair;
    private statNextTitle: RankStatPair;
    private statRaces: RankStatPair;
    private statWins: RankStatPair;

    constructor(app: App)
    {
        super(app, {
            title: 'rankStatsPopup_title',
        });

        this.div = new Sprite(Texture.WHITE);
        this.div.anchor.set(0.5);
        this.divMid.addChild(this.div);
        this.div.width = 6;
        this.div.height = 300;

        // LEFT SIDE
        this.identity = new UserIdentity();
        this.divLeft.addChild(this.identity);
        this.identity.y = -150;

        this.rankTitle = new RankTitleLabel();
        this.divLeft.addChild(this.rankTitle);
        this.rankTitle.y = this.identity.y + 40;

        this.badge = new RankBadge();
        this.divLeft.addChild(this.badge);
        this.badge.y = 7;

        this.rankPoints = new RankPointsLabel();
        this.divLeft.addChild(this.rankPoints);
        this.rankPoints.y = 150;

        // RIGHT SIDE
        const spacing = 73;

        this.statPoints = new RankStatPair();
        this.divRight.addChild(this.statPoints);
        this.statPoints.y = -150;

        this.statNextPoints = new RankStatPair();
        this.divRight.addChild(this.statNextPoints);
        this.statNextPoints.y = this.statPoints.y + spacing;

        this.statNextTitle = new RankStatPair();
        this.divRight.addChild(this.statNextTitle);
        this.statNextTitle.y = this.statPoints.y + (spacing * 2);

        this.statRaces = new RankStatPair();
        this.divRight.addChild(this.statRaces);
        this.statRaces.y = this.statPoints.y + (spacing * 3);

        this.statWins = new RankStatPair();
        this.divRight.addChild(this.statWins);
        this.statWins.y = this.statPoints.y + (spacing * 4);
    }

    protected onPresent(): void
    {
        const status = this.app.rank.getRankStatus();
        const nextRank = i18n.translate(`rankTitle_${status.nextRankTitle}`, { tier: status.nextRankTier });
        const pointsToNextRank = status.nextRankPoints - status.points;

        this.badge.refresh(status);
        this.identity.refresh();
        this.rankTitle.refresh(status.title, status.tier);
        this.rankPoints.refresh(status.points);

        this.statPoints.refresh('rankStatsPopup_totalPoints', status.points);
        this.statNextPoints.refresh('rankStatsPopup_pointsUntilNext', pointsToNextRank);
        this.statNextTitle.refresh('rankStatsPopup_nextLevel', nextRank);
        this.statRaces.refresh('rankStatsPopup_totalraces', this.app.user.getRacesPlayed());
        this.statWins.refresh('rankStatsPopup_wins', this.app.user.getRacesWon());

        Shared.game.soundSystem.playSfx('windmill');
    }
}
